import request from "@/app/api/request";
import {MessageModel, MessagesInChatRequestModel, SendMessageRequestModel} from "@/app/api/messages/models";

export class MessagesRequests {
  static async getMessages(chatId: number, page: number): Promise<MessageModel[]> {
    const query: MessagesInChatRequestModel = {chatId, page, size: 10};
    try {
      return await request.get<MessageModel[]>('messages/messagesInChat', {query});
    } catch (error: any) {
      throw error;
    }
  }

  static async sendMessage(model: SendMessageRequestModel): Promise<MessageModel> {
    try {
      return await request.post<MessageModel>('messages/sendMessage', {data: model});
    } catch (error: any) {
      throw error;
    }
  }
}

